export default __webpack_public_path__ + "static/media/TestAssign1.19ae4e97.png";